
var EmptyDocLoader = function(root, dataManager, config, userController) {
    this.root = root;
};
module.exports = EmptyDocLoader;

EmptyDocLoader.prototype.openDocument = function(doc_options) {
    var self = this;
    return new Promise(function(resolve, reject) {
        var data = new doc_options.dataClass(true);
        self.root.header = {};
        self.root.header["assetId"] = 0;
        self.root.header["assetType"] = 0;
        self.root.attachData(data);

        resolve();
    });
};

EmptyDocLoader.prototype.afterLoad = function() {
};
